<template>
  <div class="register">
    <el-main>
      <el-row>
        <el-col :span="9">
          <el-row :gutter="20">
            <el-col :span="16" :offset="4" align="canter">
              <div class="loginName">
                <el-row :gutter="20">
                  <!-- <el-col :span="12">
                    <div class="demo-image__placeholder">
                      <div class="block">
                        <el-image src="../static/imgs/shuaige1.png"></el-image>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="demo-image__placeholder">
                      <div class="block">
                        <el-image src="../static/imgs/meinv2.png"></el-image>
                      </div>
                    </div>
                  </el-col> -->
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16" :offset="4">
              <el-form :model="form" label-width="80px">
                <el-form-item label="手机号码:">
                  <el-input v-model="form.mobile" placeholder="请输入手机号"
                            suffix-icon="el-icon-user"></el-input>
                </el-form-item>
                <el-form-item label="登录密码:">
                  <el-input v-model="form.password" type="password" placeholder="请输入密码"
                            suffix-icon="el-icon-lock"></el-input>
                </el-form-item>
                <el-form-item label="重复密码:">
                  <el-input v-model="form.surePassword" type="password" placeholder="请再次输入密码"
                            suffix-icon="el-icon-lock"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="warning" @click="registerHandler" style="width: 100%;color: #FFF;background-color: #1b9af7;border-color: #1b9af7;">注册</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="15">
          <el-row :gutter="20">
            <el-col :span="20" :offset="2">
              <div class="demo-image__placeholder">
                <div class="block">
                  <el-image src="../static/imgs/registerImg.png"></el-image>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-main>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "register",
    data() {
      return {
        checked:true,
        form: {
          mobile: '',
          password: '',
          surePassword: '',
          recomId:''
        }
      }
    },
    methods: {
      ...mapActions('user', ['register']),   
      registerHandler() {
        let msg = "";
        let getPhone = (/^1[3456789]\d{9}$/).test(this.form.mobile)
        if(this.form.mobile == ''){
            msg = '请输入手机号码';
            this.$message.warning(msg);
            return
        }
        if(!getPhone){
          msg = '手机号码不正确';
          this.$message.warning(msg);
          return
        }
        if(this.form.password == '' || this.form.surePassword == ''){
            msg = '请输入密码';
            this.$message.warning(msg);
            return
        }
        if(this.form.password !== this.form.surePassword){
          this.$message.warning('两次密码输入不一致');
          return
        }
        this.form.recomId = this.$route.query.u
        this.register(this.form).then(res => {
          if(res){
            this.$message.success('注册成功!');
            this.$router.push('/login');
          }
        })
      },
      regxy(){
        window.open('/regxy');
      }
    }
  }
</script>

<style lang="less" scoped>
  .register{
    padding:2% 5% 6%;
    .agree{
       cursor: pointer;
    }
  }
  .loginDiv {
    /*width: 500px;*/
    height: 500px;
    background-color: #ffffff;
    /*border: 2px solid red;*/
    border-radius: 20px;
  }

  .loginName {
    color: #fb6a07;
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/register.vue